import { FallbackProps } from "react-error-boundary";

import HdButton from "@hd/ui-kit/hd-button/HdButton";

// Funzione per determinare se l'errore è un ChunkLoadError
const isChunkLoadError = (error: Error): boolean => {
  const chunkFailedErrorMessages = [
    "Failed to fetch dynamically imported module", // Vite/ESM
    "Loading chunk", // Webpack
    "ChunkLoadError", // Webpack
  ];
  const errorMessage = error.message || "";
  const errorName = error.name || "";
  return chunkFailedErrorMessages.some(
    (msg) =>
      errorMessage.toLowerCase().includes(msg.toLowerCase()) ||
      errorName.toLowerCase().includes(msg.toLowerCase())
  );
};

// Componente di fallback unificato
const ErrorFallback: React.FC<FallbackProps> = ({ error }) => {
  const errorIsChunkLoad = isChunkLoadError(error);

  const handleRefresh = () => {
    window.location.reload();
  };

  if (errorIsChunkLoad) {
    // UI per ChunkLoadError
    return (
      <div className="bg-bodyBg flex flex-col items-center justify-center min-h-screen p-6">
        <div className="bg-white p-8 md:p-12 rounded-xl  text-center max-w-lg">
          <h1 className="text-2xl md:text-4xl font-bold mb-4 ">
            Aggiornamento Hoteldoor
          </h1>
          <p className="text-lg md:text-xl mb-8">
            Hoteldoor si è aggiornato! Per caricare la nuova versione, premi il
            pulsante Aggiorna.
          </p>
          {/* <p className="text-sm text-slate-400 mb-2">
            Dettaglio errore: {error.message}
          </p> */}
          <HdButton
            onClick={handleRefresh}
            type="button"
            variant="primary"
            size="large"
            className="w-64 !text-lg"
            // className="bg-sky-500 hover:bg-sky-600 text-white font-semibold py-3 px-8 rounded-lg text-lg transition-colors duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-sky-400 focus:ring-opacity-75 shadow-lg"
          >
            Aggiorna
          </HdButton>
        </div>
      </div>
    );
  }

  // UI per errore generico
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-red-100 text-red-700 p-6 font-sans">
      <div className="bg-white p-8 md:p-12 rounded-xl shadow-2xl text-center max-w-md">
        <h1 className="text-2xl md:text-3xl font-bold mb-4">
          Oops! Qualcosa è andato storto.
        </h1>
        <p className="text-md md:text-lg mb-3">
          Si è verificato un errore imprevisto:
        </p>
        <p>
          <span className="text-sm">{error.message}</span>
        </p>
      </div>
    </div>
  );
};

export default ErrorFallback;
